__webpack_require__.p = "/reports-component-actions-data/referrals-hub/";